<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/" class="logo">
            <span class="logo-sm">
              <img src="@/assets/images/logos/logo-sm.jpg" alt="Header Avatar" />
            </span>
            <span class="logo-lg" >
              <img src="@/assets/images/logos/logo-white-webped.jpg" alt="Header Avatar" />
            </span>
          </a>
        </div>

        <button @click="setMiniSidebar" type="button" class="btn btn-sm px-3 font-size-24 header-item waves-effect" id="vertical-menu-btn">
          <i class="mdi mdi-menu"></i>
        </button>
      </div>

      <div class="d-flex">

        <alerta/>

        <b-dropdown id="dropdown-buttons" class="my-2">
          <template #button-content>
            <div>
              <img class="rounded-circle header-profile-user" src="@/assets/images/users/1.jpg" alt="Header Avatar" v-if="!image" />
              <img class="rounded-circle header-profile-user" :src="image" alt="Header Avatar" v-if="image" />
              <span class=" d-xl-inline-block ml-1 color-white">{{ username }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block color-white"></i>
            </div>
          </template>
          <b-dropdown-item to="meu-perfil"><i class="mdi mdi-account color-white  d-inlne-block text-muted mr-2"></i> MINHA CONTA</b-dropdown-item>
          <b-dropdown-item-button  @click="logout"><i class="mdi mdi-exit-to-app color-white d-inlne-block text-muted mr-2"></i>SAIR</b-dropdown-item-button>
          
        </b-dropdown>

        
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import { LOGOUT } from "@/store/autenticacao.module";
import { DEFINIR_IDIOMA } from "@/store/idioma.module";
import JwtService from "@/common/utils/jwt";
import { START_LOADING } from "@/store/Store";
import Swal from "sweetalert2";

import Alerta from "./Alerta.vue";

export default {
  name: "vertical-header",
  data: () => ({
    showToggle: false,
    mostrarModal: false,
    isFullscreen: false,
    abrirMenu: true
  }),
  components: {
    Alerta,
  },
  computed: {
    ...mapState(["navbarColor", "logoColor", "LayoutType", 'menuAberto']),
    username() { return (this.$store.state.app.userInfo == null ? '' : this.$store.state.app.userInfo.pessoa ? this.$store.state.app.userInfo.pessoa.nome.toUpperCase() :this.$store.state.app.userInfo.nomeUsuario) },
    image() { return this.$store.state.app.userInfo == null ? null : (this.$store.state.app.userInfo.pessoa ? this.$store.state.app.userInfo.pessoa.foto : null) },
    
    getCurrentLanguage() {
      const locale = this.$i18n.locale;
      if (locale == "en") return { lang: "flag-icon flag-icon-us" };
      else if (locale == "br") return { lang: "flag-icon flag-icon-br" };
      return this.locale;
    },
    nomeUsuario() {
      return `${JwtService.buscarNome()}`;
    },
    email() {
      return JwtService.buscarEmail();
    },
    mostrarDropdownClass() {
      return this.showToggle ? " show" : "";
    },
  },
  methods: {
    showMobileSidebar() {
      this.$store.commit("SET_SIDEBAR_DRAWER", true);
    },
    fullScreen() {
      if (this.isFullscreen == true) {
        this.isFullscreen = false;

        document.exitFullscreen();
        return;
      }

      this.isFullscreen = true;
      document.body.webkitRequestFullScreen();
    },
    toggleDropdown() {
      if (this.showToggle == false) return (this.showToggle = true);

      this.showToggle = false;
    },
    setMiniSidebar() {
      var w = window.innerWidth;
      this.abrirMenu = !this.abrirMenu;
      this.$store.dispatch('setAbrirMenu',this.abrirMenu);
  
      if(w < 992){
        this.$store.dispatch('setMenuAberto',!this.menuAberto);
      }else{
        this.$store.dispatch('setMenuAberto',true);
      }
      if (this.LayoutType == "full-sidebar") {
        this.$store.dispatch("setLayoutType", "mini-sidebar");
      } else if (this.LayoutType == "mini-sidebar") {
        this.$store.dispatch("setLayoutType", "full-sidebar");
      }
    },
    alterarIdioma(idioma) {
      this.$store.dispatch(START_LOADING);
      this.$store.dispatch(DEFINIR_IDIOMA, idioma).then(() => {
        location.reload();
      });
      this.$i18n.locale = idioma;
    },
    logout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "Login" }))
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err,
            icon: "error",
          });
        });
    },
    abrirModal() {
      this.mostrarModal = true;
    },
    fecharModal() {
      this.mostrarModal = false;
    },
    abrirPerfil(id) {
      this.$router.push({ name: "usuarios-formulario", params: { id } });
    },
  },
};
</script>
